import { Component, OnInit, OnDestroy, AfterViewInit, ElementRef, ViewChildren, QueryList, HostListener, Inject, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { RouterModule, Router } from '@angular/router';

@Component({
  selector: 'app-home',
  imports: [CommonModule, RouterModule],
  templateUrl: './home.html',
  styleUrl: './home.css'
})
export class HomeComponent implements OnInit, OnDestroy, AfterViewInit {
  // --- SLIDER ---
  currentSlide = 0;
  private slideInterval: any;
  isSliderPaused = false;

  slides = [
    {
      title: 'Especialistas en perforación de pozos tubulares profundos.',
      description: 'Captación eficiente y segura de agua subterránea para uso agrícola, industrial y doméstico.'
    },
    {
      title: 'Soluciones automatizadas para mayor eficiencia operativa.',
      description: 'Sistemas eléctricos integrales, tableros de control, PLCs, variadores de frecuencia y más.'
    },
    {
      title: 'Mantenimientos integrales de infraestructura y equipos.',
      description: 'Conservamos la operatividad de tus sistemas eléctricos, hidráulicos, sanitarios y mecánicos.'
    },
    {
      title: 'Soluciones profesionales en sistemas contra incendios.',
      description: 'Diseño, instalación, mantenimiento y pruebas hidráulicas 100% certificadas.'
    },
    {
      title: 'Equipos de bombeo para cada necesidad.',
      description: 'Venta, instalación y puesta en marcha de bombas de agua y sistemas de presión constante.'
    }
  ];

  // --- DATOS ---
  servicios = [
    {
      icon: 'diseño-perforacion-pozos-recurso.svg',
      title: 'Diseño y perforación de pozos para el abastecimiento del recurso hídrico subterráneo'
    },
    {
      icon: 'instalaciones-electromecanicas.svg',
      title: 'Instalaciones electromecánicas automatizadas'
    },
    {
      icon: 'instralacion-electricas-sistemas-control.svg',
      title: 'Instalaciones eléctricas y sistemas de control'
    },
    {
      icon: 'fabricacion-instalacion-mantenimiento-tableros.svg',
      title: 'Fabricación, instalación y mantenimiento de tableros eléctricos'
    }
  ];

  marcas = [
    { name: 'PENTAIR', img: 'https://res.cloudinary.com/dg7wvqxcv/image/upload/v1755849245/Pentair_Logo_uvjmnn.jpg' },
    { name: 'PEDROLLO', img: 'https://res.cloudinary.com/dg7wvqxcv/image/upload/v1755849244/Pedrollo-Loinsa_ajgcse.png' },
    { name: 'LUXSE', img: 'https://res.cloudinary.com/dg7wvqxcv/image/upload/v1755849244/luise_lylm9r.jpg' },
    { name: 'OROFLEX', img: 'https://res.cloudinary.com/dg7wvqxcv/image/upload/v1755849243/Oroflex-Well-logo_fxkn99.png' },
    { name: 'ITAP', img: 'https://res.cloudinary.com/dg7wvqxcv/image/upload/v1755849243/itap-logo_iwnja6.webp' },
    { name: 'EMAUX', img: 'https://res.cloudinary.com/dg7wvqxcv/image/upload/v1755849243/Emaux-600X240_hwgkon.png' },
    { name: 'PENTAX', img: 'https://res.cloudinary.com/dg7wvqxcv/image/upload/v1756023749/pentax_3_yug6xu.png' }
  ];

  clientes = [
    { name: 'Yasisa', img: 'https://res.cloudinary.com/dg7wvqxcv/image/upload/v1755763006/YASISA-LOGO_lu66ww.png' },
    { name: 'Tottus', img: 'https://res.cloudinary.com/dg7wvqxcv/image/upload/v1755763005/TOTTUS-LOGO_zeion4.png' },
    { name: 'Teiga TMI', img: 'https://res.cloudinary.com/dg7wvqxcv/image/upload/v1755763003/TEIGA-TMI_qz9r0t.png' },
    { name: 'Pesquera Diamante', img: 'https://res.cloudinary.com/dg7wvqxcv/image/upload/v1755763002/PESQUERA-DIAMANTE_lfyc2v.png' },
    { name: 'Pesquera Centinela', img: 'https://res.cloudinary.com/dg7wvqxcv/image/upload/v1755763001/PESQUERA-CENTINELA_pnbz1i.png' },
    { name: 'Modasa', img: 'https://res.cloudinary.com/dg7wvqxcv/image/upload/v1755762999/MODASA-LOGO_iyy10x.png' },
    { name: 'Lima Expresa', img: 'https://res.cloudinary.com/dg7wvqxcv/image/upload/v1755762998/LIMA-EXPRESA-LOGO_haohgq.png' },
    { name: 'Jockey Plaza', img: 'https://res.cloudinary.com/dg7wvqxcv/image/upload/v1755762996/JOCKEY-PLAZA-LOGO_rvhdbm.png' },
    { name: 'Grupo Centenario', img: 'https://res.cloudinary.com/dg7wvqxcv/image/upload/v1755762995/GRUPO-CENTENARIO_auwrrq.png' },
    { name: 'Consorcio Inti Punku', img: 'https://res.cloudinary.com/dg7wvqxcv/image/upload/v1755762994/CONSORCIO-INTI-PUNKU_mzsvaa.png' },
    { name: 'Aliex', img: 'https://res.cloudinary.com/dg7wvqxcv/image/upload/v1755762992/ALIEX-LOGO_bochkj.png' },
    { name: 'Falabella', img: 'https://res.cloudinary.com/dg7wvqxcv/image/upload/v1755762991/FALABELLA-LOGO_o3xim6.png' },
    { name: 'Almacenes del Perú', img: 'https://res.cloudinary.com/dg7wvqxcv/image/upload/v1755762989/ALMACENES-DEL-PERU_ntgwr8.png' }
  ];
  // --- PROYECTOS ALEATORIOS ---
  todosLosProyectos = [
    { titulo: "Planta de Tratamiento - SEDAPAL", imagen: "/assets/img/obra-planta-agua.jpg", link: "/portafolio/planta-sedapal" },
    { titulo: "Aeropuerto Jorge Chávez", imagen: "/assets/img/obra-aeropuerto.jpg", link: "/portafolio/aeropuerto" },
    { titulo: "Proyecto Alto Piura", imagen: "/assets/img/obra-alto-piura.jpg", link: "/portafolio/alto-piura" },
    { titulo: "Línea Amarilla", imagen: "/assets/img/obra-linea-amarilla.jpg", link: "/portafolio/linea-amarilla" },
    { titulo: "Metro de Lima", imagen: "/assets/img/obra-metro-lima.jpg", link: "/portafolio/metro-lima" }
  ];
  proyectosRandom: any[] = [];

  // --- ADMIN SECRET (KONAMI CODE) ---
  private konamiCode: string[] = [];
  private secretCode = ['r','e','h','o','b','o','t'];
  showAdminBtn = false;

  // Referencia a elementos para animar
  @ViewChildren('animarEntrada') elementosAnimados!: QueryList<ElementRef>;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private router: Router
  ) {}

  ngOnInit() {
    this.startSlideshow();
    this.seleccionarProyectosAleatorios();
  }

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.iniciarObservadorAnimaciones();
    }
  }

  ngOnDestroy() {
    this.stopSlideshow();
  }

  // SLIDER
  startSlideshow() {
    this.stopSlideshow();
    this.slideInterval = setInterval(() => {
      if (!this.isSliderPaused) {
        this.nextSlide();
      }
    }, 5000);
  }

  stopSlideshow() {
    if (this.slideInterval) {
      clearInterval(this.slideInterval);
    }
  }

  nextSlide() { this.currentSlide = (this.currentSlide + 1) % this.slides.length; }
  goToSlide(index: number) { this.currentSlide = index; this.stopSlideshow(); this.startSlideshow(); }
  onSliderHover(isHovering: boolean) { this.isSliderPaused = isHovering; }

  // PROYECTOS
  seleccionarProyectosAleatorios() {
    const shuffled = [...this.todosLosProyectos].sort(() => 0.5 - Math.random());
    this.proyectosRandom = shuffled.slice(0,2);
  }

  // ANIMACIONES
  iniciarObservadorAnimaciones() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          (entry.target as HTMLElement).classList.add('visible');
        }
      });
    }, { threshold: 0.1 });

    this.elementosAnimados.forEach(el => observer.observe(el.nativeElement));
  }

  // KONAMI
  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    const target = event.target as HTMLElement;
    if (target && (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA')) return;

    this.konamiCode.push(event.key.toLowerCase());
    if (this.konamiCode.length > this.secretCode.length) this.konamiCode.shift();

    if (this.konamiCode.join('') === this.secretCode.join('')) {
      this.showAdminBtn = true;
      this.konamiCode = [];
      setTimeout(() => this.showAdminBtn = false, 10000);
    }
  }

  irAlAdmin() { window.location.href = '/admin/login.php'; }
}
